<div class="nordic-blue-50-bg surface-secondary">
  <ul class="ribbon-list flex flex--space-around no-list-style md-col-3-10 ms-medium-y" role="list">
    @for (link of links; track $index; let i = $index) {
      <li role="listitem">
        <a
          [finLink]="link"
          class="block no-underline nordic-blue-900-text text-icon-primary font-body-2 ps-xsmall-y footer-link inline-block font-body-small"
          ><span class="valign-middle">{{ 'ondMarketing.ribbon.' + linkTranslationKeys[i] | finLocalization }}</span></a
        >
      </li>
    }
  </ul>
</div>
